/**
 * When a qty stepper inside a .product-card-qty-row is updated,
 * highlight the sibling ATC button to prompt the user to add to cart.
 * Removes the highlight when the button is clicked.
 */
function initAtcHighlight(root = document) {
  root.querySelectorAll('.product-card-qty-row').forEach((row) => {
    const qtyInput = row.querySelector('quantity-input');
    const atcBtn = row.querySelector('.product-card-btn__btn');
    const stagedAction = row.querySelector('staged-action');
    if (!qtyInput || !atcBtn) return;

    if (stagedAction) {
      stagedAction.setAttribute('persist-done', '');
    }

    qtyInput.addEventListener('update', () => {
      // Reset button to original state
      if (stagedAction) {
        stagedAction.setState('IDLE');
      }
      // Remove first to restart the CSS animation if already highlighted
      atcBtn.classList.remove('atc-highlight');
      void atcBtn.offsetWidth; // force reflow
      atcBtn.classList.add('atc-highlight');
    });

    atcBtn.addEventListener('click', () => {
      atcBtn.classList.remove('atc-highlight');
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAtcHighlight());
} else {
  initAtcHighlight();
}
